export default __webpack_public_path__ + "static/49-5396422be2668b8bef4664d4e1eb79ed.gif";